(function () {
  'use strict';

  var CART_KEY = 'tkahve_cart';

  function getCart() {
    try { return JSON.parse(localStorage.getItem(CART_KEY) || '[]'); } catch (e) { return []; }
  }

  function saveCart(c) { localStorage.setItem(CART_KEY, JSON.stringify(c)); }

  function formatMoney(n) {
    return Math.round(n).toLocaleString('tr-TR') + ' TL';
  }

  // Convert slug "colombia-supremo" → "Colombia Supremo"
  function slugToTitle(str) {
    if (!str) return '';
    return str.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  // Flag image via flagcdn.com (real country flag images)
  function flagImg(code) {
    if (!code || code.length !== 2) return '';
    var cc = code.toLowerCase();
    return '<img src="https://flagcdn.com/w40/' + cc + '.png" ' +
           'srcset="https://flagcdn.com/w80/' + cc + '.png 2x" ' +
           'width="20" height="14" alt="' + cc.toUpperCase() + '" class="cd-flag-img" loading="eager" onerror="this.style.display=\'none\'">';
  }

  // ── Drawer open/close ──────────────────────────────────────────
  function openDrawer() {
    var drawer  = document.getElementById('tkahve-cart-drawer');
    var overlay = document.getElementById('tkahve-cart-overlay');
    if (drawer)  drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderDrawer();
  }

  function closeDrawer() {
    var drawer  = document.getElementById('tkahve-cart-drawer');
    var overlay = document.getElementById('tkahve-cart-overlay');
    if (drawer)  drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Split "Espresso — Özel Blend" or "Espresso, Özel Blend" → ["Espresso", "Özel Blend"]
  function splitLabel(label) {
    if (!label) return ['', ''];
    // handle both em dash (old data) and comma (new data)
    var parts = label.split(/\s*[,\u2014]\s*/);
    return [parts[0] || '', parts.slice(1).join(', ') || ''];
  }

  // ── Render ─────────────────────────────────────────────────────
  function renderDrawer() {
    var body       = document.getElementById('tkahve-cart-body');
    var badge      = document.getElementById('tkahve-cart-badge');
    var titleCount = document.getElementById('cd-title-count');
    var cart       = getCart();

    if (badge) {
      badge.style.display = cart.length ? 'flex' : 'none';
      badge.textContent   = cart.length;
    }
    if (titleCount) {
      titleCount.textContent   = cart.length ? cart.length : '';
      titleCount.style.display = cart.length ? 'inline-flex' : 'none';
    }

    if (!body) return;

    var footer = document.getElementById('tkahve-cart-footer');

    if (!cart.length) {
      body.innerHTML =
        '<div class="cd-empty">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="opacity:0.2;margin-bottom:1rem">' +
            '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>' +
          '</svg>' +
          '<p>Sepetiniz boş</p>' +
          '<a href="/pages/siparis-olustur" class="cd-empty-btn">Sipariş Oluştur</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    var total = cart.reduce(function (s, item) { return s + item.total; }, 0);

    body.innerHTML = cart.map(function (item, idx) {
      var parts      = splitLabel(item.label);
      var labelMain  = parts[0];
      var labelSub   = parts[1];

      var hasBeans = (item.beans || []).length > 0;

      var beansSectionHtml = '';
      if (hasBeans) {
        var beansHtml = item.beans.map(function (b) {
          var displayName = (b.name && b.name !== b.id) ? b.name : slugToTitle(b.name || b.id);
          var img   = b.countryCode ? flagImg(b.countryCode) : '';
          var ratio = (b.ratio && b.ratio < 100) ? '<span class="cd-bean__ratio">%' + b.ratio + '</span>' : '';
          return '<div class="cd-bean">' +
            (img ? '<span class="cd-bean__flag-wrap">' + img + '</span>' : '') +
            '<span class="cd-bean__name">' + displayName + '</span>' +
            ratio +
          '</div>';
        }).join('');
        beansSectionHtml =
          '<div class="cd-item__section-label">ÇEKİRDEKLER</div>' +
          '<div class="cd-item__beans">' + beansHtml + '</div>';
      } else if ((item.meta || []).length) {
        var metaHtml = item.meta.map(function (m) {
          return '<div class="cd-bean">' +
            '<span class="cd-bean__name">' + m.label + '</span>' +
            '<span class="cd-bean__ratio">' + m.value + '</span>' +
          '</div>';
        }).join('');
        beansSectionHtml = '<div class="cd-item__beans">' + metaHtml + '</div>';
      }

      var qtyNote = (item.quantity && item.quantity > 1) ? (item.quantity + ' × ') : '';

      return '<div class="cd-item" data-id="' + item.id + '">' +
        '<div class="cd-item__header">' +
          '<span class="cd-item__order-num">SİPARİŞ ' + (idx + 1) + '</span>' +
          '<button class="cd-item__remove" data-action="cd-remove" data-id="' + item.id + '" type="button">Kaldır</button>' +
        '</div>' +
        '<div class="cd-item__title">' +
          labelMain +
          (labelSub ? '<span class="cd-item__subtitle">' + labelSub + '</span>' : '') +
        '</div>' +
        beansSectionHtml +
        '<div class="cd-item__meta">' +
          '<span class="cd-item__kg">' + qtyNote + item.kg + ' kg</span>' +
          '<strong class="cd-item__price">' + formatMoney(item.total) + '</strong>' +
        '</div>' +
      '</div>';
    }).join('');

    if (footer) {
      footer.style.display = 'flex';
      var totalEl = document.getElementById('tkahve-cart-total');
      if (totalEl) totalEl.textContent = formatMoney(total);
    }

    // Tadım seti aboneliğe uygun değil — data attribute ile işaretle
    var hasTadim = cart.some(function (item) { return item.type === 'tadim'; });
    var subBtn = document.getElementById('cd-sub-btn');
    if (subBtn) subBtn.dataset.tadimBlock = hasTadim ? '1' : '';
  }

  // ── Subscription panel ─────────────────────────────────────────
  var subSettings = {}; // { [itemId]: { freq, dur } }
  var subDeliveryDay = 'monday'; // shared across all items

  var FREQ_OPTS = [
    { value: 'weekly',   label: 'Haftada 1' },
    { value: 'biweekly', label: '2 Haftada 1' },
    { value: 'monthly',  label: 'Ayda 1' },
  ];
  var DUR_OPTS = [
    { value: 3, label: '3 Ay' },
    { value: 6, label: '6 Ay' },
  ];
  var DAY_OPTS = [
    { value: 'monday',    label: 'Pzt' },
    { value: 'tuesday',   label: 'Sal' },
    { value: 'wednesday', label: 'Çar' },
    { value: 'thursday',  label: 'Per' },
    { value: 'friday',    label: 'Cum' },
  ];

  function openSubPanel() {
    var cart = getCart();
    if (!cart.length) return;
    var hasTadim = cart.some(function (item) { return item.type === 'tadim'; });
    if (hasTadim) {
      alert('Tadım Seti sepette olduğu için abonelik oluşturulamaz. Lütfen Tadım Seti\'ni sepetten kaldırın.');
      return;
    }

    // Init defaults
    cart.forEach(function (item) {
      if (!subSettings[item.id]) {
        subSettings[item.id] = { freq: 'monthly', dur: 3 };
      }
    });

    renderSubPanel(cart);

    var panel = document.getElementById('cd-sub-panel');
    if (panel) panel.style.display = 'flex';
  }

  function closeSubPanel() {
    var panel = document.getElementById('cd-sub-panel');
    if (panel) panel.style.display = 'none';
  }

  var FREQ_PER_MONTH = { weekly: 4, biweekly: 2, monthly: 1 };

  // Sepete eklenirken kaydedilen süre bazlı abonelik satış fiyatı (TL/kg);
  // eski kayıtlarda yoksa tek seferlik fiyata düşer. Kesin fiyat sunucuda
  // hesaplanır; normal/abonelik farkı admin kâr çarpanlarından türediği için
  // oranlar değişince buradaki indirim gösterimi de kendiliğinden güncellenir.
  function subItemPerKg(item, dur) {
    var p = parseFloat((item.subPerKg || {})[String(dur)]) || 0;
    return p > 0 ? p : (parseFloat(item.pricePerKg) || 0);
  }

  function renderSubPanel(cart) {
    var body = document.getElementById('cd-sub-panel-body');
    if (!body) return;

    var itemsHtml = cart.map(function (item) {
      var parts = splitLabel(item.label);
      var s = subSettings[item.id] || { freq: 'monthly', dur: 3 };

      var freqChips = FREQ_OPTS.map(function (o) {
        return '<button type="button" class="cd-sub-chip' + (s.freq === o.value ? ' is-active' : '') +
          '" data-sub-freq="' + o.value + '" data-item-id="' + item.id + '">' + o.label + '</button>';
      }).join('');

      var durChips = DUR_OPTS.map(function (o) {
        return '<button type="button" class="cd-sub-chip' + (s.dur === o.value ? ' is-active' : '') +
          '" data-sub-dur="' + o.value + '" data-item-id="' + item.id + '">' + o.label + '</button>';
      }).join('');

      var oneKg = parseFloat(item.pricePerKg) || 0;
      var subKg = subItemPerKg(item, s.dur);
      var del   = (FREQ_PER_MONTH[s.freq] || 1) * s.dur;
      var qty   = item.quantity || 1;
      var priceHtml = '';
      if (subKg > 0) {
        var kgHtml;
        if (oneKg > subKg + 0.005) {
          var pct = Math.round((1 - subKg / oneKg) * 100);
          kgHtml = '<span class="sub-price-old">' + formatMoney(oneKg) + '/kg</span>' +
            '<strong>' + formatMoney(subKg) + '/kg</strong>' +
            (pct > 0 ? '<span class="sub-discount-badge">%' + pct + ' indirim</span>' : '');
        } else {
          kgHtml = '<strong>' + formatMoney(subKg) + '/kg</strong>';
        }
        var qtyNote = qty > 1 ? (qty + ' × ') : '';
        priceHtml = '<div class="cd-sub-price">' +
          '<span class="cd-sub-price__kg">' + kgHtml + '</span>' +
          '<span class="cd-sub-price__total">' + qtyNote + item.kg + ' kg × ' + del + ' teslimat = <strong>' + formatMoney(subKg * item.kg * qty * del) + '</strong></span>' +
        '</div>';
      }

      return '<div class="cd-sub-item">' +
        '<div class="cd-sub-item__name">' + (parts[0] || item.label) + '</div>' +
        '<div class="cd-sub-group">' +
          '<span class="cd-sub-group__label">Teslimat Sıklığı</span>' +
          '<div class="cd-sub-chips">' + freqChips + '</div>' +
        '</div>' +
        '<div class="cd-sub-group">' +
          '<span class="cd-sub-group__label">Abonelik Süresi</span>' +
          '<div class="cd-sub-chips">' + durChips + '</div>' +
        '</div>' +
        priceHtml +
      '</div>';
    }).join('');

    var subTotal = 0, normalTotal = 0;
    cart.forEach(function (item) {
      var st  = subSettings[item.id] || { freq: 'monthly', dur: 3 };
      var d   = (FREQ_PER_MONTH[st.freq] || 1) * st.dur;
      var q   = item.quantity || 1;
      subTotal    += subItemPerKg(item, st.dur) * item.kg * q * d;
      normalTotal += (parseFloat(item.pricePerKg) || 0) * item.kg * q * d;
    });
    var totalsHtml = '<div class="cd-sub-totals">' +
      '<div class="cd-sub-totals__row"><span>Toplam (tek ödeme)</span><strong>' + formatMoney(subTotal) + '</strong></div>' +
      (normalTotal - subTotal > 0.5 ? '<div class="cd-sub-totals__row cd-sub-totals__row--save"><span>Normal alıma göre kazancınız</span><strong>' + formatMoney(normalTotal - subTotal) + '</strong></div>' : '') +
    '</div>';

    var dayChips = DAY_OPTS.map(function (o) {
      return '<button type="button" class="cd-sub-chip' + (subDeliveryDay === o.value ? ' is-active' : '') +
        '" data-sub-day="' + o.value + '">' + o.label + '</button>';
    }).join('');

    var dayHtml = '<div class="cd-sub-item cd-sub-item--day">' +
      '<div class="cd-sub-group">' +
        '<span class="cd-sub-group__label">Teslimat Günü</span>' +
        '<div class="cd-sub-chips">' + dayChips + '</div>' +
      '</div>' +
    '</div>';

    var infoHtml = '<div class="cd-sub-info">' +
      '<p class="cd-sub-info__text">Kg fiyatınız abonelik boyunca sabitlenir; kur ve çekirdek fiyatları yükselse bile ödemeniz değişmez. Toplam tutar tek seferde ödenir.</p>' +
      '<a href="/pages/abonelik-1" class="cd-sub-info__link">Abonelik nasıl çalışır? →</a>' +
    '</div>';

    body.innerHTML = itemsHtml + dayHtml + totalsHtml + infoHtml;
  }

  function onSubPanelClick(e) {
    var btn = e.target.closest('[data-sub-freq],[data-sub-dur],[data-sub-day]');
    if (!btn) return;

    if (btn.dataset.subDay) {
      subDeliveryDay = btn.dataset.subDay;
      renderSubPanel(getCart());
      return;
    }

    var itemId = parseInt(btn.dataset.itemId);
    if (!subSettings[itemId]) subSettings[itemId] = { freq: 'monthly', dur: 3 };

    if (btn.dataset.subFreq) subSettings[itemId].freq = btn.dataset.subFreq;
    if (btn.dataset.subDur)  subSettings[itemId].dur  = parseInt(btn.dataset.subDur);

    renderSubPanel(getCart());
  }

  function doCreateSubscriptions(agreementAcceptedAt) {
    var cart = getCart();
    if (!cart.length) return;
    // Abonelik Sözleşmesi onayı zorunlu: modal onayından ISO string gelmeden
    // (click event objesi onay sayılmaz) ödemeye geçilmez; sunucu da reddeder.
    if (typeof agreementAcceptedAt !== 'string') {
      if (typeof window.tkahveAgreementConfirm !== 'function') {
        alert('Sözleşme onay penceresi yüklenemedi. Lütfen sayfayı yenileyip tekrar deneyin.');
        return;
      }
      window.tkahveAgreementConfirm(doCreateSubscriptions);
      return;
    }
    var btn = document.getElementById('cd-sub-confirm-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Oluşturuluyor...'; }

    var payload = {
      items: cart.map(function (item) {
        var s = subSettings[item.id] || { freq: 'monthly', dur: 3 };
        return {
          type:              item.type || null,
          kg:                item.kg,
          quantity:          item.quantity || 1,
          beans:             item.beans,
          label:             item.label,
          variantId:         item.variantId || null,
          blendDetails:      { beans: item.beans },
          deliveryFrequency: s.freq,
          durationMonths:    s.dur,
        };
      }),
      deliveryDay:       subDeliveryDay,
      customerId:    (window.tkahveCustomer || {}).id || null,
      customerEmail: (window.tkahveCustomer || {}).email || null,
      agreementAccepted: true,
    };

    fetch('https://toptankahve-checkout.vercel.app/api/create-cart-subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.error || 'Hata'); return d; }); })
    .then(function (data) {
      // Sepeti ödeme tamamlanınca temizle; ödemeden dönülürse sepet korunur.
      markPendingOrder(data.draftOrderId);
      window.location.href = data.checkoutUrl;
    })
    .catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Abonelik Oluştur'; }
      alert('Hata: ' + err.message);
    });
  }

  // ── Checkout ───────────────────────────────────────────────────
  function doCheckout() {
    var cart = getCart();
    if (!cart.length) return;
    var btn = document.getElementById('cd-checkout-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Yükleniyor...'; }

    fetch('https://toptankahve-checkout.vercel.app/api/create-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId:    (window.tkahveCustomer || {}).id || null,
        customerEmail: (window.tkahveCustomer || {}).email || null,
        items: cart.map(function (item) {
          return {
            type:       item.type,
            variantId:  item.variantId,
            kg:         item.kg,
            quantity:   item.quantity || 1,
            beans:      item.beans,
            label:      item.label,
            properties: item.properties,
          };
        }),
      }),
    })
    .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.error || 'Hata'); return d; }); })
    .then(function (data) {
      // Sepeti ÖDEME TAMAMLANINCA temizleyeceğiz. Şimdilik "bekleyen sipariş"
      // olarak işaretle; kullanıcı ödemeden dönerse sepet korunur.
      markPendingOrder(data.draftOrderId);
      window.location.href = data.checkoutUrl;
    })
    .catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Ödemeye Geç'; }
      alert('Hata: ' + err.message);
    });
  }

  // ── Bekleyen sipariş takibi (sepeti yalnızca ödeme tamamlanınca temizle) ──
  var PENDING_KEY = 'tkahve_pending_order';
  var ORDER_STATUS_URL = 'https://toptankahve-checkout.vercel.app/api/order-status';

  function markPendingOrder(draftOrderId) {
    if (!draftOrderId) return;
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify({ id: String(draftOrderId), at: Date.now() }));
    } catch (e) {}
  }

  function checkPendingOrder() {
    var raw;
    try { raw = localStorage.getItem(PENDING_KEY); } catch (e) { return; }
    if (!raw) return;
    var p;
    try { p = JSON.parse(raw); } catch (e) { try { localStorage.removeItem(PENDING_KEY); } catch (_) {} return; }
    if (!p || !p.id) { try { localStorage.removeItem(PENDING_KEY); } catch (e) {} return; }
    // 3 günden eskiyse takibi bırak (sepeti silme, sadece işareti kaldır).
    if (Date.now() - (p.at || 0) > 3 * 24 * 3600 * 1000) {
      try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
      return;
    }
    fetch(ORDER_STATUS_URL + '?draftId=' + encodeURIComponent(p.id))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.completed) {
          try { localStorage.removeItem('tkahve_cart'); } catch (e) {}
          try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
          try { window.dispatchEvent(new Event('tkahve:cart-updated')); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  // ── Event delegation ───────────────────────────────────────────
  function onDrawerClick(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    if (btn.dataset.action === 'cd-remove') {
      var id = parseInt(btn.dataset.id);
      saveCart(getCart().filter(function (item) { return item.id !== id; }));
      renderDrawer();
      window.dispatchEvent(new CustomEvent('tkahve:cart-updated'));
    }
    if (btn.dataset.action === 'cd-checkout') { doCheckout(); }
    if (btn.dataset.action === 'cd-sub-open') {
      window.location.href = '/pages/siparis-olustur#subscription';
    }
  }

  // ── Init ───────────────────────────────────────────────────────
  function init() {
    var toggleBtn = document.getElementById('tkahve-cart-toggle');
    if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);

    var overlay = document.getElementById('tkahve-cart-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    var closeBtn = document.getElementById('tkahve-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    var drawer = document.getElementById('tkahve-cart-drawer');
    if (drawer) drawer.addEventListener('click', onDrawerClick);

    var checkoutBtn = document.getElementById('cd-checkout-btn');
    if (checkoutBtn) checkoutBtn.addEventListener('click', doCheckout);

    // Subscription panel
    var subBtn = document.getElementById('cd-sub-btn');
    if (subBtn) subBtn.addEventListener('click', openSubPanel);

    var subBack = document.getElementById('cd-sub-back');
    if (subBack) subBack.addEventListener('click', closeSubPanel);

    var subPanelBody = document.getElementById('cd-sub-panel-body');
    if (subPanelBody) subPanelBody.addEventListener('click', onSubPanelClick);

    var subConfirmBtn = document.getElementById('cd-sub-confirm-btn');
    if (subConfirmBtn) subConfirmBtn.addEventListener('click', doCreateSubscriptions);

    window.addEventListener('tkahve:cart-updated', renderDrawer);
    renderDrawer();

    // Bekleyen sipariş ödendiyse sepeti temizle (ödemeden dönüşte sepet korunur).
    checkPendingOrder();
  }

  // ── Dışa açılan API (diğer sayfalar sepete ürün ekleyip çekmeceyi açar) ──
  window.tkahveCartAdd = function (item) {
    var cart = getCart();
    item.id = Date.now() + Math.floor(Math.random() * 1000);
    cart.push(item);
    saveCart(cart);
    window.dispatchEvent(new CustomEvent('tkahve:cart-updated'));
  };
  window.tkahveCartOpen = openDrawer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
